<template>
  <ejs-dialog
    ref="formDialog"
    id="formats-form"
    class="dialog-papirus"
    target="#dialogFormats"
    :isModal="true"
    :visible="showing"
    :header="header"
    :width="width"
    :showCloseIcon="true"
    :close="onDialogClose"
    :open="onDialogOpen"
    z-index="1003"
  >
    <div id="formatsToast"></div>
    <div class="col-lg-12 e-input-section">
      <div class="content-wrapper">
        <div class="row" v-show="showId">
          <div class="col-xs-12 col-sm-12 col-lg-2 col-md-2">
            <label class="e-text">Id Formato</label>
            <input
              id="id"
              class="e-input"
              v-model="m_data.id"
              type="text"
              disabled
              @blur="validateField('id')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6">
            <label class="e-text">Nombre Formato</label>
            <input
              id="name"
              class="e-input"
              :class="{ 'e-warning': hasError('name') }"
              type="text"
              required
              v-model="m_data.name"
              :readonly="isFormReadOnly"
              @input="validateField('name')"
              @blur="validateField('name')"
              placeholder="Nombre Formato"
            />
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('name') }"
              v-text="m_errors.name"
            >
            </span>
          </div>
          <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6">
            <label for="formatTypeId" style="padding: 0px 40px 0px 0"
              >Tipo de Formato</label
            >
            <ejs-dropdownlist
              ref="formatTypeDropDown"
              id="formatTypeId"
              :dataSource="formatTypesList"
              :fields="fields"
              v-model="m_data.formatTypeId"
              :value="m_data.formatTypeId"
              :readonly="isFormReadOnly"
              :cssClass="hasError('formatTypeId') ? 'e-warning' : ''"
              @change="validateField('formatTypeId')"
              @blur="validateField('formatTypeId')"
              placeholder="Tipo de Formato"
            ></ejs-dropdownlist>
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('formatTypeId') }"
              v-text="m_errors.formatTypeId"
            >
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6">
            <label class="e-text">Tamaño de Página</label>
            <ejs-dropdownlist
              ref="pageSizeDropDown"
              id="pageSize"
              :dataSource="pageSizeList"
              :fields="fields"
              v-model="m_data.pageSize"
              :value="m_data.pageSize"
              :readonly="isFormReadOnly"
              :cssClass="hasError('pageSize') ? 'e-warning' : ''"
              @change="validateField('pageSize')"
              @blur="validateField('pageSize')"
              placeholder="Tamaño de Página"
            ></ejs-dropdownlist>
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('pageSize') }"
              v-text="m_errors.pageSize"
            >
            </span>
          </div>
          <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6">
            <label class="e-text">Orientación de Pagina</label>
            <ejs-dropdownlist
              ref="pageOrientationDropDown"
              id="pageOrientation"
              :dataSource="pageOrientationList"
              :fields="fields"
              v-model="m_data.pageOrientation"
              :value="m_data.pageOrientation"
              :readonly="isFormReadOnly"
              :cssClass="hasError('pageOrientation') ? 'e-warning' : ''"
              @change="validateField('pageOrientation')"
              @blur="validateField('pageOrientation')"
              placeholder="Orientación de Página"
            ></ejs-dropdownlist>
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('pageOrientation') }"
              v-text="m_errors.pageOrientation"
            >
            </span>
          </div>
        </div>
        <div class="row">
          <div
            class="col-xs-12 col-sm-12 col-lg-3 col-md-3 control-section switch-control classEspecial"
          >
            <div>
              <ejs-switch
                cssClass="align-middle"
                id="isActive"
                v-model="m_data.isActive"
                :checked="m_data.isActive"
                :disabled="isFormReadOnly || !canDelete"
              ></ejs-switch>
              <label for="isActive" class="e-text align-middle switch-label">{{
                m_data.isActive ? "Activo" : "Inactivo"
              }}</label>
            </div>
          </div>
          <div
            class="col-xs-12 col-sm-12 col-lg-3 col-md-3 control-section switch-control classEspecial"
          >
            <div>
              <ejs-switch
                cssClass="align-middle"
                id="isUrl"
                v-model="m_data.isUrl"
                :checked="m_data.isUrl"
                :disabled="isFormReadOnly || !canDelete"
              ></ejs-switch>
              <label for="isUrl" class="e-text align-middle switch-label">{{
                m_data.isUrl ? "Es Url" : "No es Url"
              }}</label>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-lg-3 col-md-3">
            <ejs-radiobutton
              label="Es Archivo PDF"
              name="default"
              cssClass="align-middle"
              :change="radioChange"
              :checked="m_data.isFile"
              :disabled="isFormReadOnly || !canDelete"
              value="isFile"
            ></ejs-radiobutton>
          </div>
          <div class="col-xs-12 col-sm-12 col-lg-3 col-md-3">
            <ejs-radiobutton
              label="Es Plantilla HTML"
              name="default"
              cssClass="align-middle"
              :change="radioChange"
              :checked="m_data.isTemplate"
              :disabled="isFormReadOnly || !canDelete"
              value="isTemplate"
            ></ejs-radiobutton>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
            <div class="">
              <label class="e-text">Ruta Documento</label>
              <input
                id="name"
                class="e-input"
                :class="{ 'e-warning': hasError('fileLocation') }"
                type="text"
                required
                v-model="m_data.fileLocation"
                :readonly="isFormReadOnly"
                @input="validateField('fileLocation')"
                @blur="validateField('fileLocation')"
                placeholder="Ruta Documento"
              />
              <span
                class="help e-text small"
                :class="{ 'e-warning': hasError('fileLocation') }"
                v-text="m_errors.fileLocation"
              >
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
            <label class="e-text"
              >DataMaps Requeridos para el Presente Formato</label
            >
            <ejs-listview
              ref="listaFormatDataMaps"
              class="e-input"
              id="lista-datamaps-formatos"
              height="200px"
              showCheckBox="true"
              checkBoxPosition="Left"
            ></ejs-listview>
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('listaDatamaps') }"
              v-text="m_errors.listaDatamaps"
            >
            </span>
          </div>
        </div>
        <div class="row pull-right">
          <div class="col-xs-12 col-sm-12">
            <div class="e-btn-group">
              <ejs-button
                @click.native="validateForm"
                :isPrimary="true"
                iconCss="e-icons icon-save inline-command"
                cssClass="e-flat e-noback"
                v-if="showSaveButton"
                :disabled="disableButtons"
                >Grabar</ejs-button
              >
              <ejs-button
                :isDanger="true"
                iconCss="e-icons icon-trash inline-command"
                cssClass="e-flat e-danger e-noback"
                v-if="showDeleteButton"
                :disabled="disableButtons"
                >Desactivar
              </ejs-button>
              <ejs-button
                @click.native="close()"
                iconCss="e-icons icon-cancel inline-command"
                cssClass="e-flat e-noback"
                :disabled="disableButtons"
                >Cancelar</ejs-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </ejs-dialog>
</template>

<script>
import Vue from "vue";

import { FormActionEnum } from "../../services/enums.js";
import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";
// import CultureMixin from "../../mixins/CultureMixin";

/* Plugins de Syncfusion */

import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { SwitchPlugin } from "@syncfusion/ej2-vue-buttons";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import { TooltipPlugin } from "@syncfusion/ej2-vue-popups";
import { RadioButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { ListViewPlugin } from "@syncfusion/ej2-vue-lists";
Vue.use(RadioButtonPlugin);
Vue.use(ListViewPlugin);

/* Utilidades Syncfusion */
import {
  createSpinner,
  showSpinner,
  hideSpinner
} from "@syncfusion/ej2-popups";

/* Validación con YUP*/

import * as Yup from "yup";
import { es } from "yup-locales";
import { setLocale } from "yup";
setLocale(es);

Vue.use(DialogPlugin);
Vue.use(ButtonPlugin);
Vue.use(SwitchPlugin);
Vue.use(DropDownListPlugin);
Vue.use(TooltipPlugin);

export default Vue.extend({
  mixins: [PermissionMixin, ToastMixin],
  computed: {
    showId() {
      return this.formAction !== FormActionEnum.ADD && this.formAction !== FormActionEnum.DUPLICATE;
    },
    showSaveButton() {
      return (
        this.formAction === FormActionEnum.ADD ||
        this.formAction === FormActionEnum.EDIT ||
        this.formAction === FormActionEnum.DUPLICATE
      );
    },
    showDeleteButton() {
      return this.formAction == FormActionEnum.DELETE;
    },
    customClass() {
      return {
        "dialog-papirus": true,
        "dialog-edit":
          this.formAction == FormActionEnum.ADD ||
          this.formAction == FormActionEnum.EDIT ||
          this.formAction == FormActionEnum.DUPLICATE,
        "dialog-view": this.formAction == FormActionEnum.VIEW,
        "dialog-delete": this.formAction == FormActionEnum.DELETE
      };
    },
    isFormReadOnly() {
      var ret = false;

      switch (this.formAction) {
        case FormActionEnum.ADD, FormActionEnum.DUPLICATE:
          break;
        case FormActionEnum.EDIT:
          break;
        case FormActionEnum.VIEW:
          ret = true;
          break;
        case FormActionEnum.DELETE:
          ret = true;
          break;
      }
      return ret;
    },
    header() {
      if (this.formAction === FormActionEnum.ADD || this.formAction === FormActionEnum.DUPLICATE) {
        return "Nuevo Formato";
      }
      if (this.formAction === FormActionEnum.VIEW) {
        return "Consultar Formato";
      }
      if (this.formAction === FormActionEnum.EDIT) {
        return "Modificar Formato";
      }
      if (this.formAction === FormActionEnum.DELETE) {
        return "Deshabilitar Formato";
      }
      return "";
    },
    canDelete() {
      if (!this.hasPermission("CanDelete")) {
        return false;
      }
      return true;
    },
    disableButtons() {
      return this.isSaving;
    },
    formatTypesList() {
      let formatTypes = this.$store.getters["formatTypes/allFormatTypes"];
      const newArray = JSON.parse(JSON.stringify(formatTypes));
      return newArray
        .filter(function (formatType) {
          return formatType.isActive === true;
        })
        .map(function (row) {
          return { id: row.id, name: row.description };
        });
    }
  },
  data() {
    return {
      /* Datos del Componente*/
      isValid: false,
      isSaving: false,
      validationSchema: {},
      m_errors: {},
      m_data: {},
      fields: { text: "name", value: "id" },
      isModal: true,
      target: document.getElementById("dialog"),
      width: this.isMobile ? "500px" : "70%",
      pageSizeList: [],
      pageOrientationList: [],
      dataMaps: [],
      fileType: "isUrl"
    };
  },
  created() {},
  async mounted() {
    try {
      createSpinner({
        target: this.$refs.formDialog.$el
      });
      this.buildYupSchema();

      var pageSizes = await this.$store.dispatch(
        "minosParameters/getParameterValuesByCode",
        { code: "PAGE_SIZES", returnObject: true }
      );
      this.pageSizeList = pageSizes
        .filter((x) => x.active === true)
        .map(function (row) {
          return { id: row.stringValue, name: row.description };
        });

      var pageOrientation = await this.$store.dispatch(
        "minosParameters/getParameterValuesByCode",
        { code: "PAGE_ORIENTATION", returnObject: true }
      );
      this.pageOrientationList = pageOrientation
        .filter((x) => x.active === true)
        .map(function (row) {
          return { id: row.stringValue, name: row.description };
        });

      var dataMaps = await this.$store.dispatch("audit/getTableData", {
        schemaName: "papirus",
        tableName: "DataMaps"
      });

      this.dataMaps = JSON.parse(JSON.stringify(dataMaps.data));
    } catch (error) {
      console.log(error);
    }
  },
  updated() {},
  provide: {},
  methods: {
    async onDialogOpen() {
      try {
        this.showSpinner();

        this.m_data = Object.assign({}, this.formData);
        this.m_data.dataMaps = [];
        var hasProfile = !!this.m_data.formatTypeId;
        if (!hasProfile) {
          Vue.set(this.m_data, "formatTypeId", null);
        }
        if (this.formAction == FormActionEnum.ADD || this.formAction == FormActionEnum.DUPLICATE) {
          this.m_data.isTemplate = true;
          this.m_data.isNew = true;

          //si es nuevo la lista no se setea
        }
        if (this.formAction != FormActionEnum.ADD) {
          //si es nuevo la lista no se setea
          this.m_data.isNew = false;
          //Obtener toda la información, incluyendo los datamaps.
          await this.$store.dispatch("formats/getFormat", this.formData.id);
          this.m_data = Object.assign(
            {},
            this.$store.getters["formats/currentFormat"]
          );
        }

        this.setDuplicate();

        setTimeout(() => {
          if (this.formAction == FormActionEnum.ADD || this.formAction == FormActionEnum.DUPLICATE) this.m_errors = [];
        }, 500);
        this.$refs.listaFormatDataMaps.ej2Instances.dataSource =
          this.getListData();

        if (
          this.formAction == FormActionEnum.VIEW ||
          this.formAction == FormActionEnum.DELETE ||
          this.formAction == FormActionEnum.SPECIAL
        ) {
          this.$refs.listaFormatDataMaps.ej2Instances.enable = false;
        } else {
          this.$refs.listaFormatDataMaps.ej2Instances.enable = true;
        }
        this.hideSpinner();
      } catch (error) {
        console.log(error);
        this.hideSpinner();
      }
    },
    getListData() {
      var instance = this;
      var hasData = instance.dataMaps && instance.dataMaps.length > 0;
      if (!hasData) return [];
      var formatId = instance.m_data.id;
      var ret = this.dataMaps.map(function (dm) {
        var dfltItem = {
          text: `${dm.Key}: ${dm.Name}`,
          id: `${dm.Id}`,
          formatId: formatId,
          dataMapId: parseInt(dm.Id)
        };

        if (instance.m_data.dataMaps == undefined) return dfltItem;

        var maps = JSON.parse(JSON.stringify(instance.m_data.dataMaps));
        var hasDataMaps = maps && maps.length > 0;
        if (!hasDataMaps) return dfltItem;
        else {
          var dMap = maps.find(
            (x) => x.formatId == formatId && x.dataMapId == dm.Id
          );

          if (dMap == null || dMap == undefined) {
            return dfltItem;
          } else {
            dfltItem.isChecked = true;
            dfltItem.formatId = dMap.formatId;
            dfltItem.dataMapId = dMap.dataMapId;
            return dfltItem;
          }
        }
      });
      return ret;
    },
    onDialogClose() {
      try {
        this.$refs.listaFormatDataMaps.ej2Instances.dataSource = [];
        this.clearErrors();
        this.m_data = {
          id: 0,
          formatTypeId: null,
          name: "",
          pageSize: null,
          pageOrientation: null,
          fileLocation: "",
          isUrl: false,
          isFile: false,
          isTemplate: false,
          isActive: false
        };
        this.m_errors = [];
        this.$emit("formClosed");
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.$refs.formDialog.hide();
      this.onDialogClose();
    },
    showSpinner() {
      showSpinner(this.$refs.formDialog.$el);
    },
    hideSpinner() {
      hideSpinner(this.$refs.formDialog.$el);
    },
    clearErrors() {
      this.m_errors = {};
    },
    async saveData() {
      try {
        this.isSaving = true;
        this.showSpinner();       
        switch (this.formAction) {
          case FormActionEnum.VIEW:
            this.showToast(
              "No habilitado",
              "Modo consulta, nada para grabar!",
              2000
            );
            break;
          case FormActionEnum.ADD:
            this.m_data.isActive = true;
            await this.$store.dispatch("formats/createFormat", this.m_data);        
            this.showToast("Confirmación", "Registro Creado!", 2000);
            break;
          case FormActionEnum.DUPLICATE:
            this.m_data.isActive = true;
            await this.$store.dispatch("formats/createFormat", this.m_data);        
            this.showToast("Confirmación", "Registro Creado!", 2000);
            break;
          case FormActionEnum.EDIT:
            await this.$store.dispatch("formats/updateFormat", {
              id: this.m_data.id,
              format: JSON.parse(JSON.stringify(this.m_data))
            });
            this.showToast("Confirmación", "Registro Actualizado", 2000);
            break;
        }
        await this.$store.dispatch("formats/getFormats");
        /* esperar medio segundo antes de cerrar */
        setTimeout(() => {
          this.isSaving = false;
          this.hideSpinner();
          this.close();
        }, 500);
      } catch (error) {
        this.isSaving = false;
        this.hideSpinner();
        this.showToast(
          "Error!",
          "Ocurrió un error al ejecutar la operación",
          2000
        );
      }
    },
    buildYupSchema() {
      this.validationSchema = Yup.object().shape({
        isNew: Yup.boolean(),
        name: Yup.string().required().max(100).label("Formato"),
        formatTypeId: Yup.number()
          .nullable()
          .required()
          .label("Tipo de Formato")
          .typeError("Seleccione Tipo de Formato"),
        pageSize: Yup.string()
          .nullable()
          .required()
          .label("Tamaño de Página")
          .typeError("Seleccione Tamaño de Página"),
        pageOrientation: Yup.string()
          .nullable()
          .required()
          .label("Orientación de Página")
          .typeError("Seleccione Orientación de Página"),
        fileLocation: Yup.string().required().max(1024).label("Ruta Documento")
      });
    },
    hasError(field) {
      return !!this.m_errors[field];
    },
    async validateField(field) {
      Vue.set(this.m_errors, field, "");

      if (this.isFormReadOnly) return;

      this.validationSchema.validateAt(field, this.m_data).catch((err) => {
        Vue.set(this.m_errors, err.path, err.message);
      });
    },
    async validateForm() {
      try {
        await this.validationSchema.validate(this.m_data, {
          abortEarly: false
        });

        //validar la informacion seleccionada
        //OHG 2022/01/20, Permito que graben el formato sin DataMaps
        // var selected = this.$refs.listaFormatDataMaps.getSelectedItems();
        // if (selected.data.length == 0) {
        //   Vue.set(
        //     this.m_errors,
        //     "listaDatamaps",
        //     "Debe Seleccionar un DataMap"
        //   );
        //   return;
        // } else if (selected.data.length > 0) {
        //   this.m_data.dataMaps = selected.data.map(function (x) {
        //     return { formatId: x.formatId, dataMapId: x.dataMapId };
        //   });
        // }

        var selected = this.$refs.listaFormatDataMaps.getSelectedItems();
        if (selected.data.length > 0) {
          this.m_data.dataMaps = selected.data.map(function (x) {
            return { formatId: x.formatId, dataMapId: x.dataMapId };
          });
        } else {
          this.m_data.dataMaps = [];
        }

        this.m_errors = {};
        await this.saveData();
      } catch (error) {
        error.inner.forEach((error) => {
          Vue.set(this.m_errors, error.path, error.message);
        });
      }
    },
    getFormatData() {
      //Validar si esta seleccionado0 en el actual.
    },
    radioChange(args) {
      this.m_data.isFile = false;
      this.m_data.isTemplate = false;
      if (args.value == "isFile") this.m_data.isFile = true;
      if (args.value == "isTemplate") this.m_data.isTemplate = true;
    },
    setDuplicate(){
      if(this.formAction == FormActionEnum.DUPLICATE){
        this.m_data.id = 0;
        this.m_data.name = "";
        if (this.m_data.dataMaps != undefined && this.m_data.dataMaps != null){
          var dataMaps = this.m_data.dataMaps.map(function (item) {
            return {
              dataMapId: item.dataMapId,
              formatId: 0,
              removed: item.removed
            };
          });
          this.m_data.dataMaps = dataMaps;
        }
      }
    }
  },
  props: {
    /** Whether the dialog is currently showing */
    showing: {
      type: Boolean,
      required: true,
      default: false
    },
    formAction: {
      type: Number,
      required: true,
      default: 0
    },
    isMobile: {
      type: Boolean,
      required: true,
      default: false
    },
    formData: {
      type: Object,
      required: false,
      default() {
        return {
          id: 0,
          formatTypeId: 0,
          name: "",
          pageSize: "",
          pageOrientation: "",
          fileLocation: "",
          isUrl: false,
          isFile: false,
          isTemplate: false,
          isActive: false
        };
      }
    }
  }
});
</script>

<style scoped>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-dropdowns/styles/fabric.css);
@import url(../form-icons.css);

.classEspecial {
  align-self: center;
}

.dialog-papirus.e-dialog .e-dlg-header {
  color: #0078d6;
  font-size: 20px;
  font-weight: normal;
}

.content-wrapper div.row {
  padding: 5px 0px;
}

.switch-label {
  padding: 0px 0px 0px 20px;
  margin: auto;
  cursor: pointer;
}

.e-save.e-icons:before,
.e-save.e-icons:before {
  content: "\e609";
}

.e-listview {
  background: #fff;
  border-color: #999;
  color: #666;
  border: 1px solid;
}
.e-listview:focus {
  border-color: #0078d6;
  color: #fff;
}

@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }

  .e-input-section .col-xs-6,
  .e-input-section .col-xs-4,
  .e-input-section .col-xs-12 {
    padding: 10px 5px;
    width: 100%;
  }

  .content-wrapper div.row {
    padding: 0px;
  }
}
</style>
